import apiClient from '../api-client';
import apiClientPost from '@/services/util/apiClientPost';

export default {
	async saveAlerts(payload) {
		const endpoint = '/PreferenceCenter/SaveUserPreferences';

			try {
				const data = await apiClientPost(endpoint, payload);
				return Promise.resolve(data);
			} catch (error) {
				return Promise.reject(error);
			}
	},

	async getAllPreferences(userIds) {
		const endpoint = '/PreferenceCenter/GetAllPreferences';
		const payload = 'All';
		try {
			const { data } = await apiClient().post(endpoint, { userIds, payload });
			return Promise.resolve(data);
		} catch (error) {
			return Promise.reject(error);
		}
	},
};
